import React from 'react';
import { CTAButton } from '../CTAButton';
const PHOTO = 'https://cdn.magicpatterns.com/uploads/d4mbQNzHmMEAnoGN2ZDUcp/Dra_Karito_real.png';
export function Author() {
  return <section className="w-full bg-[#FBF8F3] px-5 py-14 sm:px-6 sm:py-20" data-id="element-59" data-mp="1wgf157e0bc0w">
      <div className="mx-auto max-w-4xl" data-id="element-60" data-mp="1wirtmehe54s7">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#17808D]" data-id="element-61" data-mp="1rpowjwdend79">
          🏥 Sull’autrice
        </p>
        <h2 className="mt-3 text-center font-display text-[2rem] font-bold leading-tight text-[#0E3B42] sm:text-[2.6rem]" data-id="element-62" data-mp="25fimyj4k65j3">
          Dott.ssa Karito
        </h2>

        <div className="mt-8 grid gap-6 sm:grid-cols-[minmax(0,15rem)_1fr] sm:items-start sm:gap-8" data-id="element-63" data-mp="2ffsx1uvaqwu1">
          <img src={PHOTO} alt="Ritratto della Dott.ssa Karito in camice bianco" className="mx-auto aspect-[3/4] w-full max-w-[17rem] rounded-2xl object-cover object-top shadow-[0_20px_50px_-24px_rgba(14,59,66,0.6)] sm:max-w-none" width={943} height={1674} loading="lazy" data-id="element-64" data-mp="2ahhp5pokaweg" />

          <div className="space-y-4 text-[14.5px] leading-relaxed text-[#3F5F64] sm:text-[15px]" data-id="element-65" data-mp="3kfxxeumk6583">
            <p data-id="element-66" data-mp="3pf140ji6sji6">
              La Dott.ssa Karito ha creato Percorso Clinico GLP-1™ con un
              obiettivo molto chiaro: trasformare uno dei trattamenti che oggi
              genera più dubbi in una sequenza di decisioni cliniche semplici,
              ordinate e supportate dalle evidenze.
            </p>
            <p data-id="element-67" data-mp="7yavtfuilybz">
              Dopo aver analizzato le principali linee guida internazionali e
              condensato migliaia di pagine di informazioni, ha sviluppato una
              metodologia pratica che permette a qualsiasi medico di seguire lo
              stesso percorso che seguirebbe uno specialista, dalla selezione del
              paziente fino al follow-up a lungo termine.
            </p>
            <p className="rounded-xl bg-white p-4 font-medium text-[#0E3B42]" data-id="element-68" data-mp="2iq2ln35jbjb0">
              Il risultato è un Percorso Clinico progettato per risparmiare
              tempo, ridurre l’incertezza e aumentare la sicurezza nella
              prescrizione dei GLP-1.
            </p>
          </div>
        </div>

        <CTAButton className="mt-9" label="Voglio seguire il suo percorso clinico" subline="Metodo basato sulle linee guida ADA, AACE ed EASD" data-id="element-69" data-mp="3v2g6j7uc9j9x" />
      </div>
    </section>;
}